import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=cd66849e&scoped=true"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Opportunity.vue?vue&type=style&index=0&id=cd66849e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd66849e",
  null
  
)

export default component.exports